<!--
    视频模块
-->
<template>
  <div class="volvoxc60 wondalful">
    <div class="swiper-wrap">
      <div class="gallery-thumbs-box clear">
        <div
          @click="clickNav(index)"
          v-for="(item, index) in thumbsList"
          :key="index"
          class="thumb"
          :class="{ active: activeIndex == index }"
        >
          <div class="tab" :class="{ active: activeIndex == index }">
            <div class="logo">
              <img :src="item.logo" alt="" />
              <span class="title">
                <span class="special">{{ item.title }}</span>
                <!-- <img v-if="activeIndex == index" class="nick" :src="item.img" alt="">
                <img v-else class="nick" :src="item.disable" alt=""> -->
                <p><span class="special3">{{item.start}}</span><span class="special2">{{item.strong}}</span><span class="special3">{{item.end}}</span></p>
              </span>
            </div>
            <div v-if="activeIndex == index" class="tab-cont">
              {{ item.des }}
            </div>
          </div>
          <div
            v-if="activeIndex == index"
            class="swiper-container gallery-top"
            :class="['swiper-container' + index]"
          >
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index2) in imgs[index]"
                :key="index2"
              >
                <div class="driverSelf">
                  <img :src="item.imgSrc" alt="" />
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <!-- <div
            v-if="imgs[index].length > 1 && activeIndex == index"
            @click="goNext"
            class="swiper-next"
          ></div>
          <div
            v-if="imgs[index].length > 1 && activeIndex == index"
            @click="goPrev"
            class="swiper-prev"
          ></div> -->
        </div>
      </div>
    </div>
    <img
      src="https://source.qunarzz.com/site/images/wns/20220429-shijianchen-lookmore.png"
      class="lookmore"
      @click="showDialog"
      alt=""
    />
  </div>
</template>
<script>
import yuyue from './dialog/yuyue/index'
let vm = null;
export default {
  data() {
    return {
      activeIndex: 0,
      thumbsList: [
        {
          logo: "https://source.qunarzz.com/site/images/wns/20220427-shijianchen-logo3.png",
          title: "@TINNY",
          start:"沃尔沃",
          end:"车主",
          strong:"xc90",
          img:"https://source.qunarzz.com/site/images/wns/20220430-shijianchen-nick2.png",
          disable:"https://source.qunarzz.com/site/images/wns/20220430-shijianchen-nick2_1.png",
          des: "日落横琴金满江。在喜欢你的人眼中，每个角度都是最美角度。 ",
        },
        {
          logo: "https://source.qunarzz.com/site/images/wns/20220427-shijianchen-logo1.png",
          title: "@SPIDER",
          start:"沃尔沃",
          end:"车主",
          strong:"xc60",
          img:"https://source.qunarzz.com/site/images/wns/20220430-shijianchen-nick3.png",
          disable:"https://source.qunarzz.com/site/images/wns/20220430-shijianchen-nick3_1.png",
          des: "当金黄的内蒙草原遇到初秋，夜幕降临， 北半球的星空，更显繁星闪烁。 ",
        },
        {
          logo: "https://source.qunarzz.com/site/images/wns/20220429-shijianchen-logo.png",
          title: "@肖邦的自驾旅行与露营",
          start:"沃尔沃",
          end:"纯电版",
          strong:"xc40",
          img:"https://source.qunarzz.com/site/images/wns/20220430-shijianchen-nick1-2.png",
          disable:"https://source.qunarzz.com/site/images/wns/20220430-shijianchen-nick1_1.png",
          des: "XC40带我去心中的诗和远方，开沃尔沃的女孩超酷的好吗？ ",
        },
      ],
      swiperLists: {
        0: null,
        1: null,
        2: null,
        3: null,
      },
      indexList:{
        0:1,
        1:1,
        2:1,
        3:1
      },
      imgs: [
        [
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-card2_11.png",
          },
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-card2_22.png",
          },
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-card2_33.png",
          },
        ],
        [
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-60-1.png",
          },
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-60-2.png",
          },
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-60-3.png",
          }
        ],
        [
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220429-shijianchen-car3_4.png",
          },
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220429-shijianchen-car3_1.png",
          },
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220429-shijianchen-car3_2.png",
          },
          {
            imgSrc:
              "https://source.qunarzz.com/site/images/wns/20220429-shijianchen-car3_3.png",
          },
        ]
      ],
    };
  },
  mounted() {
    vm = this;
    this.initSwiper();
  },
  methods: {
    showDialog(){
      yuyue({

      })
    },
    initSwiper() {
      this.swiperLists[this.activeIndex] = new Swiper(
        ".volvoxc60 .swiper-container" + this.activeIndex,

        {
          autoplay: {
            disableOnInteraction: false,
            delay: 3000, //1秒切换一次
          },
          pagination: {
            el:
              ".volvoxc60 .swiper-container" +
              this.activeIndex +
              " .swiper-pagination",
          },
          on: {
            slideChangeTransitionEnd: function () {
              vm.indexList[vm.activeIndex] = this.realIndex + 1
            },
          }
        }
      );
    },
    goNext() {
      let swiper = this.swiperLists[this.activeIndex];
      swiper.slideNext();
    },
    goPrev() {
      let swiper = this.swiperLists[this.activeIndex];
      swiper.slidePrev();
    },
    clickNav(index) {
      this.activeIndex = index;
      this.$nextTick(() => {
        this.initSwiper();
      });
    },
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: "VolvoBroad";
  src: url("https://source.qunarzz.com/site/images/wns/Volvo Novum-Medium.otf");
}
@font-face {
  font-family: "SourceHanSansCN";
  src: url("https://source.qunarzz.com/site/images/wns/Volvo Novum-Medium.otf");
}
@font-face {
  font-family: "VolvoBroadPro";
  src: url("./VolvoBroad.ttf");
}
.special{
  font-family: "VolvoBroad";
}
.special2{
  font-family: "VolvoBroadPro";
  font-size: 16px;
  letter-spacing: 1px;
  margin-left:1px;
  margin-right:1px;
}
.special3{
  font-family: "SourceHanSansCN";
  font-size:13px;
}
.gallery-thumbs-box {
  width: calc(100% - 16px);
  margin-left: 8px;
  margin-right: 8px;
}
.wondalful {
  padding-top: 120px;
  position: relative;
}
.nick{
  height:13px;
  margin-top:4px;
}
.tab {
  // background:url(https://source.qunarzz.com/site/images/wns/20220427-shijianchen-tab1.png) no-repeat;
  // background-size:100% 100%;
  // background:url(https://source.qunarzz.com/site/images/wns/20220427-shijianchen-cardbg.png) no-repeat;
  // background-size:100% 100%;
  background-color: #f1f3f4;
  padding: 12px;
  padding-bottom: 0;
  img {
    display: block;
  }
}
.lookmore {
  position: absolute;
  height: 14px;
  left: 50%;
  transform: translateX(-50%);
  top: 800px;
  z-index: 100;
}
strong{
  font-size:16px;
}
.tab {
  // border-radius: 6px;
  opacity: 0.8;
  &.active {
    border-radius: 6px;
    opacity: 1;
  }
  .logo {
    display: flex;
    font-size: 14px;
    color: #a7a7a7;
    padding-bottom: 12px;
    position: relative;
    align-items: center;
    .bianhao {
      position: absolute;
      right: 0;
      top: 0;
      color: #6381a0;
    }
    >img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .title {
      text-align: left;
      padding-top: 3px;
      padding-bottom:5px;
    }
    .tit-p {
      display: block;
      font-size: 11px;
    }
  }
  &.active {
    .logo {
      color: #53565A;
      >img{
        width:47px;
        height: 47px;
      }
    }
  }
  .tab-cont {
    text-align: left;
    font-size: 13px;
    color:#989999;
    padding-bottom: 34px;
  }
}
.pos{
  position: absolute;
  width:36px;
  height:17px;
  font-size:12px;
  color:#fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index:10;
  right:10px;
  top:10px;
  background-color: rgba(0,0,0,.2);
  border-radius: 8px;
}
.thumb {
  width: 100%;
  box-sizing: border-box;
  color: #486278;
  text-align: center;
  font-weight: bold;
  position: relative;
  font-size: 16px;
  overflow: hidden;
  z-index: 2;
  .driverSelf {
    img {
      height: 247px;
      overflow: hidden;
    }
  }
  &.thumb:nth-child(2){
    position: relative;
    top:-16px;
  }
  &.thumb:nth-child(3){
    position: relative;
    top:-32px;
  }
  &.active {
    position: relative;
    color: #fff;
    &:after {
      content: unset;
    }
    .logo{
      >img{
        border:1px solid #8DA2C0;
        border-radius: 50%;
        
      }
    }
  }
  &:last-child {
    margin-right: 0;
  }
  &:first-child {
    margin-left: 0;
  }
}
.gallery-top {
  height: 247px;
  position: relative;
  top:-16px;
}
.swiper {
  &-wrap {
    position: relative;
  }
  &-next,
  &-prev {
    background: url(https://picbed.qunarzz.com/80d357495b4ae2af14e7abc355f0597a.png)
      no-repeat;
    background-size: 100% auto;
    background-position: center center;
    position: absolute;
    top: 160px;
    z-index: 20;
    width: 16px;
    height: 38px;
  }
  &-next {
    right: 8px;
  }
  &-prev {
    left: 8px;
    background-image: url(https://picbed.qunarzz.com/2bb4217666b9f683ba8aa0de070da123.png);
  }
}
</style>